import { IconButton, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceXxs, ColorGray200, ColorWhite, CardShadow } from "@nxt-costco-com/forge-design-tokens";
import { BUTTON_SIZE, BUTTON_PADDING, SIZE, BUTTON_CONTAINER_SIZE, TYPES } from "./types.js";
const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (props) => props !== "size"
})`
    width: ${(props) => props.size ? BUTTON_SIZE[props.size] : BUTTON_SIZE[SIZE.MEDIUM]};
    height: ${(props) => props.size ? BUTTON_SIZE[props.size] : BUTTON_SIZE[SIZE.MEDIUM]};
    borderradius: ${SpaceXxs};
    padding: ${(props) => props.size ? BUTTON_PADDING[props.size] : BUTTON_PADDING[SIZE.MEDIUM]};
    cursor: pointer;
    :focus-visible {
        outline-offset: 2px;
        outline: 2px solid Highlight;
        outline: 2px solid -webkit-focus-ring-color;
    }
    :hover {
        backgroundcolor: transparent;
    }
`;
const ButtonContainer = styled(Box, {
  shouldForwardProp: (props) => props !== "size" && props !== "variant"
})(({ size, type }) => ({
  width: size ? BUTTON_CONTAINER_SIZE[size] : BUTTON_CONTAINER_SIZE[SIZE.MEDIUM],
  height: size ? BUTTON_CONTAINER_SIZE[size] : BUTTON_CONTAINER_SIZE[SIZE.MEDIUM],
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  boxShadow: type === TYPES.CONTAINED ? CardShadow : "none",
  backgroundColor: ColorWhite,
  alignItems: "center",
  "&:hover": {
    cursor: "pointer",
    backgroundColor: ColorGray200
  }
}));
export {
  ButtonContainer,
  StyledIconButton
};
